import {Component, input, output} from '@angular/core';
import {TableModule} from 'primeng/table';
import {TranslatePipe} from '@ngx-translate/core';
import {DatePipe} from '@angular/common';
import {DevDirective} from '../../../../directives/dev.directive';
import {ElciaButton} from '../../../../components/buttons/button/button';
import {CreditNotePeppolSummary} from '../../../../../api';

@Component({
  selector: 'elcia-outgoing-credit-notes-grid',
  imports: [TableModule, TranslatePipe, DatePipe, DevDirective, ElciaButton],
  templateUrl: './outgoing-credit-notes-grid.component.html',
  styleUrl: './outgoing-credit-notes-grid.component.scss',
})
export class OutgoingCreditNotesGrid {
  outgoingCreditNotes = input.required<CreditNotePeppolSummary[]>();

  onDownloadCreditNote = output<CreditNotePeppolSummary>();
  onDownloadAttachment = output<CreditNotePeppolSummary>();

  protected downloadCreditNotePeppol(creditNote: CreditNotePeppolSummary): void {
    this.onDownloadCreditNote.emit(creditNote);
  }

  protected downloadAttachments(creditNote: CreditNotePeppolSummary): void {
    this.onDownloadAttachment.emit(creditNote);
  }
}
